// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCall\ApiPortCall.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Barge, BargeData, BargeOptions } from 'data/models/Barge';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { GeoActivity, GeoActivityData, GeoActivityOptions } from 'data/models/GeoActivity';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { JobOrder, JobOrderData, JobOrderOptions } from 'data/models/JobOrder';
import { LogEvent, LogEventData, LogEventOptions } from 'data/models/LogEvent';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { Port, PortData, PortOptions } from 'data/models/Port';
import { PortCallChange, PortCallChangeData, PortCallChangeOptions } from 'data/models/PortCallChange';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { PortCallVersion, PortCallVersionData, PortCallVersionOptions } from 'data/models/PortCallVersion';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';
import { ScheduleDateEntity, ScheduleDateEntityData, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';
import { SharingToken, SharingTokenData, SharingTokenOptions } from 'data/models/SharingToken';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';

// PortCallData is the class that PortCall serializes to/from
export interface PortCallData {
    Id : number;
    Url : string | null;
	
    Agent : PCUserData | null;
    AgentId : number;
    Barge : BargeData | null;
    BargeId : number | null;
    Batch : RecurringBatchData | null;
    BatchId : number | null;
    Change : ChangeData | null;
    ChangeId : number;
    Changes : PortCallChangeData[] | null;
    ChangesUrl : string | null;
    GeoActivities : GeoActivityData[] | null;
    Itinerary : ItineraryPointData[] | null;
    JobOrders : JobOrderData[] | null;
    Log : LogEventData[] | null;
    Port : PortData | null;
    PortId : number;
    Requestor : PCUserData | null;
    RequestorId : number;
    Schedule : ScheduleDateEntityData[] | null;
    Self : PortCallSelfData | null;
    Sharing : SharingTokenData | null;
    SharingId : number;
    TopicCards : TopicCardData[] | null;
    Version : PortCallVersionData | null;
    Vessel : VesselData | null;
    VesselId : number | null;
	
    AirDraft : NullableMeasurementData;
    DeepDraft : NullableMeasurementData;
    Guid : /* GUID */ string;
    LastPortOfCall : string | null;
    LengthOnlyLength : NullableMeasurementData;
    NextPortOfCall : string | null;
    Unlisted : boolean;
    UnlistedOverride : boolean | null;
    VoyageNumber : string | null;
}

// PortCallOptions is the class which may be passed to the PortCall constructor to define optional initial data values
export interface PortCallOptions {
    Id : number;
    Url? : string | null;
	
    Agent? : PCUserOptions | null;
    AgentId? : number;
    Barge? : BargeOptions | null;
    BargeId? : number | null;
    Batch? : RecurringBatchOptions | null;
    BatchId? : number | null;
    Change? : ChangeOptions | null;
    ChangeId? : number;
    Changes? : PortCallChangeOptions[] | null;
    ChangesUrl? : string | null;
    GeoActivities? : GeoActivityOptions[] | null;
    Itinerary? : ItineraryPointOptions[] | null;
    JobOrders? : JobOrderOptions[] | null;
    Log? : LogEventOptions[] | null;
    Port? : PortOptions | null;
    PortId? : number;
    Requestor? : PCUserOptions | null;
    RequestorId? : number;
    Schedule? : ScheduleDateEntityOptions[] | null;
    Self? : PortCallSelfOptions | null;
    Sharing? : SharingTokenOptions | null;
    SharingId? : number;
    TopicCards? : TopicCardOptions[] | null;
    Version? : PortCallVersionOptions | null;
    Vessel? : VesselOptions | null;
    VesselId? : number | null;
	
    AirDraft? : NullableMeasurementOptions;
    DeepDraft? : NullableMeasurementOptions;
    Guid? : /* GUID */ string;
    LastPortOfCall? : string | null;
    LengthOnlyLength? : NullableMeasurementOptions;
    NextPortOfCall? : string | null;
    Unlisted? : boolean;
    UnlistedOverride? : boolean | null;
    VoyageNumber? : string | null;
}

export class PortCall {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Agent : DataSignal<PCUser | null>;
    public AgentId : DataSignal<number>;
    public Barge : DataSignal<Barge | null>;
    public BargeId : DataSignal<number | null>;
    public Batch : DataSignal<RecurringBatch | null>;
    public BatchId : DataSignal<number | null>;
    public Change : DataSignal<Change | null>;
    public ChangeId : DataSignal<number>;
    public Changes : SDataArray<PortCallChange>;
    public ChangesUrl : DataSignal<string | null>;
    public GeoActivities : SDataArray<GeoActivity>;
    public Itinerary : SDataArray<ItineraryPoint>;
    public JobOrders : SDataArray<JobOrder>;
    public Log : SDataArray<LogEvent>;
    public Port : DataSignal<Port | null>;
    public PortId : DataSignal<number>;
    public Requestor : DataSignal<PCUser | null>;
    public RequestorId : DataSignal<number>;
    public Schedule : SDataArray<ScheduleDateEntity>;
    public Self : DataSignal<PortCallSelf | null>;
    public Sharing : DataSignal<SharingToken | null>;
    public SharingId : DataSignal<number>;
    public TopicCards : SDataArray<TopicCard>;
    public Version : DataSignal<PortCallVersion | null>;
    public Vessel : DataSignal<Vessel | null>;
    public VesselId : DataSignal<number | null>;
	
    public AirDraft : NullableMeasurement;
    public DeepDraft : NullableMeasurement;
    public Guid : DataSignal<string>;
    public LastPortOfCall : DataSignal<string | null>;
    public LengthOnlyLength : NullableMeasurement;
    public NextPortOfCall : DataSignal<string | null>;
    public Unlisted : DataSignal<boolean>;
    public UnlistedOverride : DataSignal<boolean | null>;
    public VoyageNumber : DataSignal<string | null>;

    constructor();
    constructor(data : PortCallOptions);
    constructor(data: PortCallOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Agent = S.value<PCUser | null>(null);
        this.AgentId = jsonableObservable(S.value<number>(data && data.AgentId !== undefined ? data.AgentId : 0));
        this.Barge = S.value<Barge | null>(null);
        this.BargeId = jsonableObservable(S.value<number | null>(data && data.BargeId !== undefined ? data.BargeId : null));
        this.Batch = S.value<RecurringBatch | null>(null);
        this.BatchId = jsonableObservable(S.value<number | null>(data && data.BatchId !== undefined ? data.BatchId : null));
        this.Change = S.value<Change | null>(null);
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Changes = SArray<PortCallChange>([]);
        this.ChangesUrl = jsonableObservable(S.value<string | null>(data && data.ChangesUrl !== undefined ? data.ChangesUrl : null));
        this.GeoActivities = SArray<GeoActivity>([]);
        this.Itinerary = SArray<ItineraryPoint>([]);
        this.JobOrders = SArray<JobOrder>([]);
        this.Log = SArray<LogEvent>([]);
        this.Port = S.value<Port | null>(null);
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
        this.Requestor = S.value<PCUser | null>(null);
        this.RequestorId = jsonableObservable(S.value<number>(data && data.RequestorId !== undefined ? data.RequestorId : 0));
        this.Schedule = SArray<ScheduleDateEntity>([]);
        this.Self = S.value<PortCallSelf | null>(null);
        this.Sharing = S.value<SharingToken | null>(null);
        this.SharingId = jsonableObservable(S.value<number>(data && data.SharingId !== undefined ? data.SharingId : 0));
        this.TopicCards = SArray<TopicCard>([]);
        this.Version = S.value<PortCallVersion | null>(null);
        this.Vessel = S.value<Vessel | null>(null);
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
	    
        this.AirDraft = data && data.AirDraft !== undefined ? new NullableMeasurement(data.AirDraft) : new NullableMeasurement();
        this.DeepDraft = data && data.DeepDraft !== undefined ? new NullableMeasurement(data.DeepDraft) : new NullableMeasurement();
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LastPortOfCall = jsonableObservable(S.value<string | null>(data && data.LastPortOfCall !== undefined ? data.LastPortOfCall : null));
        this.LengthOnlyLength = data && data.LengthOnlyLength !== undefined ? new NullableMeasurement(data.LengthOnlyLength) : new NullableMeasurement();
        this.NextPortOfCall = jsonableObservable(S.value<string | null>(data && data.NextPortOfCall !== undefined ? data.NextPortOfCall : null));
        this.Unlisted = jsonableObservable(S.value<boolean>(data && data.Unlisted !== undefined ? data.Unlisted : false));
        this.UnlistedOverride = jsonableObservable(S.value<boolean | null>(data && data.UnlistedOverride !== undefined ? data.UnlistedOverride : null));
        this.VoyageNumber = jsonableObservable(S.value<string | null>(data && data.VoyageNumber !== undefined ? data.VoyageNumber : null));
    }

    static key(obj : PortCall) {
        return obj.Id();
    }
    
    static dataKey(obj : PortCallOptions) {
        return obj.Id;
    }

    static update(obj : PortCall, data : PortCallOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.AgentId !== undefined) obj.AgentId(data.AgentId);
            if (data.BargeId !== undefined) obj.BargeId(data.BargeId);
            if (data.BatchId !== undefined) obj.BatchId(data.BatchId);
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.ChangesUrl !== undefined) obj.ChangesUrl(data.ChangesUrl);
            if (data.PortId !== undefined) obj.PortId(data.PortId);
            if (data.RequestorId !== undefined) obj.RequestorId(data.RequestorId);
            if (data.SharingId !== undefined) obj.SharingId(data.SharingId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.AirDraft !== undefined) NullableMeasurement.update(obj.AirDraft, data.AirDraft);
            if (data.DeepDraft !== undefined) NullableMeasurement.update(obj.DeepDraft, data.DeepDraft);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.LastPortOfCall !== undefined) obj.LastPortOfCall(data.LastPortOfCall);
            if (data.LengthOnlyLength !== undefined) NullableMeasurement.update(obj.LengthOnlyLength, data.LengthOnlyLength);
            if (data.NextPortOfCall !== undefined) obj.NextPortOfCall(data.NextPortOfCall);
            if (data.Unlisted !== undefined) obj.Unlisted(data.Unlisted);
            if (data.UnlistedOverride !== undefined) obj.UnlistedOverride(data.UnlistedOverride);
            if (data.VoyageNumber !== undefined) obj.VoyageNumber(data.VoyageNumber);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PortCall.ts